

















import HotNewsItem from './components/hot-news-item.vue';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { HotNews } from '@/types/home-newest';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './components/content-loader.vue';
import Container from '@/components/v3/container.vue';
import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { getHotNewsList } from './api';

export default defineComponent({
  name: 'HotNews',
  components: {
    HotNewsItem,
    BaseComponent,
    ContentLoader,
    Container,
  },
  setup() {
    // 是否展示热门资讯模块
    const showHotNewsModule = ref(true);
    // 热门资讯是否准备完毕
    const isHotNewsReady = ref(false);
    const hotNewsList = ref<HotNews[]>([]);
    onMounted(async () => {
      const [err, hotNewsListRes] = await to(getHotNewsList());
      if (err) {
        showHotNewsModule.value = false;
        throw new CustomException(err, 'getHotNewsListFail', '获取热门资讯列表失败');
      }
      isHotNewsReady.value = true;
      hotNewsList.value = hotNewsListRes;
      showHotNewsModule.value = hotNewsList.value.length > 0;
    });
    return {
      showHotNewsModule,
      isHotNewsReady,
      hotNewsList,
    };
  },
});
